'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["rotationAngle", "onChange"];
import PropTypes from 'prop-types';
import I18n from 'I18n';
import { toolbarI18nKey } from '../../constants/toolbar';
import SplitLabelStepperInput from './SplitLabelStepperInput';
import { useDebouncedOnChange } from '../../hooks/useDebouncedOnChange';
import { jsx as _jsx } from "react/jsx-runtime";
const propTypes = {
  rotationAngle: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired
};
function RotationAngleToolbarControl(props) {
  const {
      rotationAngle,
      onChange
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const [handleDimensionInputChange, handleDimensionStepChange] = useDebouncedOnChange(onChange);
  return /*#__PURE__*/_jsx(SplitLabelStepperInput, Object.assign({}, rest, {
    className: "m-right-2",
    tooltip: I18n.text(toolbarI18nKey('tooltip.rotation')),
    label: "\xB0",
    value: rotationAngle,
    max: 360,
    size: 3,
    onChange: handleDimensionInputChange,
    onStep: handleDimensionStepChange
  }));
}
RotationAngleToolbarControl.propTypes = propTypes;
RotationAngleToolbarControl.displayName = 'RotationAngleToolbarControl';
export default RotationAngleToolbarControl;